import _ from 'lodash'

export function buildSiteOptions({
  organizationSites = [],
  accountSiteId = null,
  t,
}) {
  const sortedSites = _.chain(organizationSites)
    .map(site => {
      return {
        ...site,
        text: site.name,
        value: site.id,
        label: site.id === accountSiteId ? t('common.my_site') : null,
        subtitle: t(`countries.${site.countryCodes[0]}`),
        subtitleIcon: 'mdi-earth',
      }
    })
    .orderBy('text', 'asc')
    .value()

  const accountSiteIndex = sortedSites.findIndex(
    site => site.id === accountSiteId
  )

  if (accountSiteIndex > 0) {
    const [accountSite] = sortedSites.splice(accountSiteIndex, 1)
    sortedSites.unshift(accountSite)
  }

  return sortedSites
}
